// Travel-fee estimator for the Lower Mainland.
// $5/km beyond a 30km radius of base, capped at $200. Straight-line (haversine)
// estimate from the guest's postal FSA — final quote always confirmed manually.

// ---- Base of operations (adjust these two numbers to change the radius anchor) ----
// Brentwood, Burnaby (FSA V5C / V5G area). Update if base changes.
export const BASE = { name: "Burnaby (Brentwood)", lat: 49.2664, lng: -122.9995 };

export const FREE_RADIUS_KM = 30;
export const PER_KM = 5;
export const FEE_CAP = 200;

const CITY = {
  Vancouver: [49.25, -123.12],
  Burnaby: [49.248, -122.98],
  Richmond: [49.1666, -123.1336],
  Surrey: [49.19, -122.849],
  Coquitlam: [49.2838, -122.7932],
  "Port Coquitlam": [49.262, -122.781],
  "Port Moody": [49.283, -122.831],
  "New Westminster": [49.2057, -122.911],
  "North Vancouver": [49.32, -123.07],
  "West Vancouver": [49.3286, -123.16],
  Langley: [49.1013, -122.6091],
  Delta: [49.0847, -123.0587],
  "White Rock": [49.0253, -122.8029],
  "Maple Ridge": [49.2193, -122.5984],
  "Pitt Meadows": [49.233, -122.69],
  Abbotsford: [49.0504, -122.3045],
  Mission: [49.1337, -122.3115],
  Chilliwack: [49.1579, -121.9515],
};

const FSA_CITY = {
  V5K: "Vancouver", V5L: "Vancouver", V5M: "Vancouver", V5N: "Vancouver", V5P: "Vancouver",
  V5R: "Vancouver", V5S: "Vancouver", V5T: "Vancouver", V5V: "Vancouver", V5W: "Vancouver",
  V5X: "Vancouver", V5Y: "Vancouver", V5Z: "Vancouver", V6A: "Vancouver", V6B: "Vancouver",
  V6C: "Vancouver", V6E: "Vancouver", V6G: "Vancouver", V6H: "Vancouver", V6J: "Vancouver",
  V6K: "Vancouver", V6L: "Vancouver", V6M: "Vancouver", V6N: "Vancouver", V6P: "Vancouver",
  V6R: "Vancouver", V6S: "Vancouver", V6T: "Vancouver", V6Z: "Vancouver", V7X: "Vancouver", V7Y: "Vancouver",
  V5A: "Burnaby", V5B: "Burnaby", V5C: "Burnaby", V5E: "Burnaby", V5G: "Burnaby", V5H: "Burnaby",
  V5J: "Burnaby", V3J: "Burnaby", V3N: "Burnaby",
  V6V: "Richmond", V6W: "Richmond", V6X: "Richmond", V6Y: "Richmond",
  V7A: "Richmond", V7B: "Richmond", V7C: "Richmond", V7E: "Richmond",
  V3R: "Surrey", V3S: "Surrey", V3T: "Surrey", V3V: "Surrey", V3W: "Surrey", V3X: "Surrey",
  V3Z: "Surrey", V4A: "Surrey", V4N: "Surrey", V4P: "Surrey",
  V3B: "Port Coquitlam", V3C: "Port Coquitlam", V3E: "Coquitlam", V3K: "Coquitlam", V3H: "Port Moody",
  V3L: "New Westminster", V3M: "New Westminster",
  V7G: "North Vancouver", V7H: "North Vancouver", V7J: "North Vancouver", V7K: "North Vancouver",
  V7L: "North Vancouver", V7M: "North Vancouver", V7N: "North Vancouver", V7P: "North Vancouver", V7R: "North Vancouver",
  V7S: "West Vancouver", V7T: "West Vancouver", V7V: "West Vancouver", V7W: "West Vancouver",
  V1M: "Langley", V2Y: "Langley", V2Z: "Langley", V3A: "Langley", V4W: "Langley",
  V4C: "Delta", V4E: "Delta", V4G: "Delta", V4K: "Delta", V4L: "Delta", V4M: "Delta",
  V4B: "White Rock",
  V2W: "Maple Ridge", V2X: "Maple Ridge", V4R: "Maple Ridge", V3Y: "Pitt Meadows",
  V2S: "Abbotsford", V2T: "Abbotsford", V3G: "Abbotsford", V4X: "Abbotsford",
  V2V: "Mission", V4S: "Mission",
  V2P: "Chilliwack", V2R: "Chilliwack", V4Z: "Chilliwack",
};

function haversineKm(a, b, c, d) {
  const R = 6371, toRad = (x) => (x * Math.PI) / 180;
  const dLat = toRad(c - a), dLng = toRad(d - b);
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a)) * Math.cos(toRad(c)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
}

// Returns null until a recognizable FSA is present.
export function estimateTravel(postal) {
  if (!postal) return null;
  const fsa = postal.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 3);
  if (fsa.length < 3) return null;
  const city = FSA_CITY[fsa];
  if (!city || !CITY[city]) return { unknown: true };
  const [lat, lng] = CITY[city];
  const distanceKm = Math.round(haversineKm(BASE.lat, BASE.lng, lat, lng));
  const beyond = Math.max(0, distanceKm - FREE_RADIUS_KM);
  const fee = Math.min(FEE_CAP, beyond * PER_KM);
  return { city, distanceKm, fee, withinRadius: fee === 0, capped: beyond * PER_KM > FEE_CAP };
}
